import { render, staticRenderFns } from "./PostsList.vue?vue&type=template&id=d8fa751e&scoped=true"
import script from "./PostsList.vue?vue&type=script&lang=js"
export * from "./PostsList.vue?vue&type=script&lang=js"
import style0 from "./PostsList.vue?vue&type=style&index=0&id=d8fa751e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fa751e",
  null
  
)

export default component.exports